import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import timeDown from './modules/timeCount'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    timeDown
  }
})
export default store
